import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: "/login",
    // component: () => import('../views/Login.vue')
  },

  {
    path: '/login',
    name: 'Login',
    // redirect: "/login",
    component: () => import('../views/Login.vue')
  },
  {
    path: '/admin',
    component: () => import('../views/Admin.vue'),
    redirect: "/admin/goodslist",
    meta: { title: "南孔阙里" },
    children: [
      { path: 'info', name: '修改信息', component: () => import('../views/Info.vue')},
      { path: 'goodslist', name: '商品列表', component: () => import('../views/Goodslist.vue')},
      { path: 'purchaselist', name: '购买列表', component: () => import('../views/Purchaselist.vue')},
      { path: 'userlist', name: '用户列表', component: () => import('../views/Userlist.vue')},
      // { path: 'Courselist', name: '卖家列表', component: () => import('../views/Courselist.vue')},
      // { path: 'Countcitystu', name: '规格管理', component: () => import('../views/Countcitystu.vue')},
      // { path: 'FilePage', name: '文件', component: () => import('../views/FilePage.vue')},
      {
        path: 'CouponForm',
        name: '优惠券管理',
        component: () => import('../views/CouponForm.vue')
      },
      {
        path: 'Refund',
        name: '退款管理',
        component: () => import('../views/Refund.vue')
      },
      {
        path: 'Shelf',
        name: '上架管理',
        component: () => import('../views/Shelf.vue')
      },
      {
        path: 'Deliver',
        name: '送货人专属',
        component: () => import('../views/Deliver.vue')
      },
      {
        path: 'Goodsdetail',
        name: '商品详情',
        component: () => import('../views/Goodsdetail.vue')
      },
      {
        path: 'ImportOrder',
        name: '订单导出专属',
        component: () => import('../views/ImportOrder.vue')
      },
      {
        path: 'textall',
        name: '发送短信专属',
        component: () => import('../views/textall.vue')
      },
    ]
  },
  
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path:'/changePwd',
    name:'ChangePwd',
    component: () => import ('../views/ChangePwd.vue')
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  localStorage.setItem("currentPathName", to.name) //设置当前的路由名称，为了在Header组件中去使用
  store.commit("setPath") //触发store的数据更新
  const token = localStorage.getItem("token")
  console.log(to.path)
  if (to.path === "/login" || to.path === "/register") {
    next() // 登录界面不需要token
  } else {
    if (token) { // 验证有无token
      next()
    } else {
      alert("请先登录")
      router.push("/login")
    }
  }
})

export default router